import { splitPath } from '../../utils/file-utils/file-utils';

export const virtualFileDownloadServiceModule = angular
  .module('Q.services.virtual-file-download-service', [])

  .factory(
    'virtualFileDownloadService',
    function ($window, $document, $timeout) {
      function download(filename, contents, type = 'text/plain') {
        // ignore leading path in file name
        filename = splitPath(filename).filename;

        if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
          // Manage IE11+ & Edge
          const blob = new Blob([contents], { type });
          $window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const doc = $document[0];
          const fakeLink = doc.createElement('a');
          doc.body.appendChild(fakeLink);

          fakeLink.setAttribute(
            'href',
            'data:application/octet-stream;charset=utf-8,' +
              encodeURIComponent(contents),
          );
          fakeLink.setAttribute('download', filename);
          fakeLink.click();
          $timeout(() => {
            // clean up 10s later
            doc.body.removeChild(fakeLink);
          }, 10000);
        }
      }

      return {
        download,
      };
    },
  );
